import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { cardDropShadowStyleMixin } from 'components/lib/ui/Card';
import FlexContainer from 'components/lib/ui/FlexContainer';
import MonarchLogo from 'components/lib/ui/MonarchLogo';
import ProgressBar from 'components/lib/ui/ProgressBar';
import ButtonIcon from 'components/lib/ui/button/ButtonIcon';
import DefaultButton from 'components/lib/ui/button/DefaultButton';
import Header from 'components/routes/Header';

import { variables } from 'common/lib/theme/dynamic';

const StyledProgressBar = styled(ProgressBar)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
`;

const Container = styled(FlexContainer)`
  flex: 1;
`;

const StyledHeader = styled(Header)`
  background-color: ${variables.color.background.fullscreenHeader};
  ${cardDropShadowStyleMixin}
`;

const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSize.large};
`;

type Props = {
  progress: number;
  onClickBack: () => void;
  onClickCancel?: () => void;
  cancelButtonText?: string;
  title?: string;
  showBackButton?: boolean;
};

const SetupHeader = ({
  progress,
  onClickBack,
  onClickCancel,
  cancelButtonText,
  title,
  showBackButton = true,
}: Props) => {
  const { goBack } = useHistory();

  return (
    <StyledHeader showSidebarToggle={false}>
      <Container alignCenter justifyBetween>
        <Container alignCenter>
          {showBackButton && (
            <DefaultButton onClick={onClickBack ?? goBack}>
              <ButtonIcon name="arrow-left" />
              <span>Back</span>
            </DefaultButton>
          )}
        </Container>
        {title ? <Title>{title}</Title> : <MonarchLogo dark />}
        <Container alignCenter justifyEnd>
          <DefaultButton onClick={onClickCancel}>{cancelButtonText ?? 'Cancel'}</DefaultButton>
        </Container>
      </Container>
      <StyledProgressBar value={progress} color="orange" backgroundColor="white" animated />
    </StyledHeader>
  );
};

export default SetupHeader;
